import { Link, useLocation } from "react-router-dom"
import { HugeiconsIcon } from "@hugeicons/react"
import {
  FolderIcon,
  Home01Icon,
  MoreHorizontalCircle01Icon,
  Search01Icon,
  Task01Icon,
} from "@hugeicons/core-free-icons"

import { cn } from "@/lib/utils"
import { useSidebar } from "@/components/ui/sidebar"
import { useWorkspace } from "@/workspaces/WorkspaceContext"

const ITEMS = [
  { label: "Главная", url: "/home", icon: Home01Icon },
  { label: "Задачи", url: "/tasks", icon: Task01Icon },
  { label: "Проекты", url: "/projects", icon: FolderIcon },
]

export function MobileBottomNav({ onOpenSearch }: { onOpenSearch: () => void }) {
  const { pathname } = useLocation()
  const { path } = useWorkspace()
  const { setOpenMobile } = useSidebar()

  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 border-t bg-background/95 pb-[env(safe-area-inset-bottom)] shadow-[0_-8px_24px_rgba(15,23,42,0.08)] backdrop-blur md:hidden">
      <div className="grid h-16 grid-cols-5 px-1">
        {ITEMS.map((item) => {
          const href = path(item.url)
          const active = pathname === href || pathname.startsWith(`${href}/`)
          return (
            <Link
              key={item.url}
              to={href}
              className={cn(
                "flex min-h-11 flex-col items-center justify-center gap-1 rounded-md text-[11px] font-medium text-muted-foreground",
                active && "text-foreground",
              )}
            >
              <HugeiconsIcon icon={item.icon} strokeWidth={2} className="size-5" />
              <span>{item.label}</span>
            </Link>
          )
        })}
        <button
          type="button"
          onClick={onOpenSearch}
          className="flex min-h-11 flex-col items-center justify-center gap-1 rounded-md text-[11px] font-medium text-muted-foreground"
        >
          <HugeiconsIcon icon={Search01Icon} strokeWidth={2} className="size-5" />
          <span>Поиск</span>
        </button>
        <button
          type="button"
          onClick={() => setOpenMobile(true)}
          className="flex min-h-11 flex-col items-center justify-center gap-1 rounded-md text-[11px] font-medium text-muted-foreground"
        >
          <HugeiconsIcon icon={MoreHorizontalCircle01Icon} strokeWidth={2} className="size-5" />
          <span>Ещё</span>
        </button>
      </div>
    </nav>
  )
}
